import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import AppStore from '../../store/AppStore'
import QualitometerPanel from './qualitometer/QualitometerPanel'
import DtoDetailStation from '../dto/DtoDetailStation'
import DtoDetailStationNetwork from '../dto/DtoDetailStationNetwork'
import PiezometerPanel from './piezometer/PiezometerPanel'
import DtoDetailPiezometerMeasure from '../dto/DtoDetailPiezometerMeasure'
import DtoPiezometerMeasure from '../../dashboard/dto/DtoPiezometerMeasure'
import DtoDetailStationSamplingSurfacePoint from '../dto/DtoDetailStationSamplingSurfacePoint'
import DtoPickupOperation from '../dto/DtoPickupOperation'
import DtoAnalysis from '../dto/DtoAnalysis'
import DetailStationAction from '../actions/DetailStationAction'
import HomeAction from '../../home/actions/HomeAction'
import DescriptionStationPanel from './description/DescriptionStationPanel'
import NetworkPanel from './network/NetworkPanel'
import MapDetailStationPanel from './map/MapDetailStationPanel'
import SamplingSurfacePointPanel from './samplingSurfacePoint/SamplingSurfacePointPanel'
import SiteTypes from '../../utils/mapUtils/SiteTypes'
import IndustrialSitePanel from './industrialSite/IndustrialSitePanel'
import PollutedSoilPanel from './pollutedSoil/PollutedSoilPanel'
import ConfirmationModal from '../../components/modal/ConfirmationModal'
import UUID from 'uuid'
import DashboardAction from '../../dashboard/actions/DashboardAction'
import { PANEL_DASHBOARD, PANEL_DETAIL } from '../constants/DetailStationConstants'
import DtoCity from '../../referential/dto/DtoCity'
import ReferentialAction from '../../referential/actions/ReferentialAction'
import { getDevelopmentPanel } from '../../utils/DevelopmentUtil'
import i18n from 'simple-react-i18n'

const $ = window.$

class DetailStationApp extends Component {
	constructor(props) {
		super(props)
		this.state = {
			height: 250,
			visualisation: PANEL_DASHBOARD,
			id: UUID.v4()
		}
	}

	componentWillMount() {
		AppStore.dispatch(DetailStationAction.fetchDetailSation(this.props.params.id))
		if (this.props.cities.length === 0) {
			AppStore.dispatch(ReferentialAction.fetchCities())
		}
	}

	componentWillUnmount() {
		AppStore.dispatch(DetailStationAction.reset())
	}

	componentDidMount() {
		this.onChange('app')
		const scrollTrigger = 200 // px
		const backToTop = function () {
			let scrollTop = $(window).scrollTop()
			if (scrollTop > scrollTrigger) {
				$('#back-to-top').addClass('show')
			} else {
				$('#back-to-top').removeClass('show')
			}
		}
		backToTop()
		$(window).on('scroll', () => {
			backToTop()
		})
		this.setState({
			height: document.documentElement.clientHeight - 64
		})
	}


	componentWillReceiveProps(nextprops) {
		const title = (() => {
			if (nextprops.station && nextprops.station.site) {
				if (nextprops.station.site.name && nextprops.station.code) {
					return nextprops.station.site.name + ' (' + nextprops.station.code + ')'
				}
				return i18n.stationForm
			}
			return i18n.stationForm
		})()
		AppStore.dispatch(HomeAction.setTitle(title))
	}

	getSamplingSurfacePointPanel = () => {
		if (this.props.samplingSurfacePoints.length > 0) {
			return (
				<SamplingSurfacePointPanel/>
			)
		}
		return null
	}

	getPiezometerPanel = () => {
		if (this.props.piezometerMeasures.length > 0) {
			return (
				<PiezometerPanel id={ this.props.params.id }/>
			)
		}
		return null
	}
	getQualitometerPanel = () => {
		if (this.props.analysis.length > 0) {
			return (
				<QualitometerPanel id={ this.props.params.id }/>
			)
		}
		return null
	}
	getNetworkPanel = () => {
		if (this.props.networks.length > 0) {
			return (
				<NetworkPanel networks={ this.props.networks }/>
			)
		}
		return null
	}
	onChange = (id) => {
		$('#' + id).animatescroll({ scrollSpeed: 500 })
	}

	change = (value) => {
		this.setState({
			visualisation: value
		})
	}
	exportStation = () => {
		AppStore.dispatch(DetailStationAction.exportStation(this.props.params.id))
	}
	openModal = () => {
		$('#' + this.state.id).modal('open')
	}
	getContent = () => {
		if (this.props.station.natureStation && this.props.station.natureStation[0] == SiteTypes.INDUSTRIAL_SITE.type) {
			return (
				<div className='col s12 no-padding'>
					{ this.getStationFunction(false, false) }
					<div className='col s12 no-padding'>
						<div className='row no-margin'>
							<div className='row no-margin'>
								<div className='col s12 m12 padding-top-10'>
									<DescriptionStationPanel/>
									<IndustrialSitePanel height={ this.state.height }/>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		} else if (this.props.station.natureStation && this.props.station.natureStation[0] == SiteTypes.POLLUTED_SOIL.type) {
			return (
				<div className='col s12 no-padding'>
					{ this.getStationFunction(false, false) }
					<div className='col s12 no-padding'>
						<div className='row no-margin'>
							<div className='row no-margin'>
								<div className='col s12 m12 padding-top-10'>
									<DescriptionStationPanel/>
									<PollutedSoilPanel height={ this.state.height }/>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		if (this.state.visualisation === PANEL_DETAIL) {
			const divStyle = {
				maxHeight: this.state.height,
				overflowX: 'none',
				overflowY: 'auto'
			}
			return (
				<div className='col s12 no-padding'>
					{ this.getStationFunction() }
					<div className='col s12 no-padding'>
						<div className='row no-margin'>
							<div className='col s4' style={ divStyle }>
								<DescriptionStationPanel detail/>
								{ this.getNetworkPanel() }
								{ this.getSamplingSurfacePointPanel() }
							</div>
							<div className='col s8 no-padding'><MapDetailStationPanel height={ this.state.height }/></div>
						</div>
					</div>
				</div>

			)
		}
		const piezoQualito = (() => {
			const panelPiezo = this.getPiezometerPanel()
			const panelQualito = this.getQualitometerPanel()
			if (panelPiezo) {
				if (panelQualito) {
					return (
						<div>
							{ panelPiezo } { panelQualito }
						</div>)
				}
				return (
					<div>
						{ panelPiezo }
					</div>)
			}
			if (panelQualito) {
				return (<div>
						{ panelQualito }
					</div>
				)
			}
			return (
				<div className='row valign-wrapper inDevelop' style={ { minHeight: 'calc(90% - 64px)', paddingBottom: '0px' } }>
					<div className='row'>
						<div className='col s12 m12 l12'>
							{ getDevelopmentPanel(true) }
						</div>
					</div>
				</div>
			)
		})()
		return (
			<div className='col s12 no-padding'>
				{ this.getStationFunction() }
				<div className='col s12 no-padding'>
					<div className='row no-margin'>
						<div className='row no-margin'>
							<div className='col s12 m12 padding-top-10'>
								<DescriptionStationPanel/>
							</div>
						</div>
						{ piezoQualito }
						<a onClick={ () => this.onChange('app') } id='back-to-top'>
							<span/>
						</a>
					</div>
				</div>
			</div>

		)
	}

	getStationFunction = (detail = true, active = true) => {
		const exportButton = (() => {
			if (!active) {
				return (<a className='btn secondary-color white-text' onClick={ () => this.exportStation() } disabled>{ i18n.exportFunction }</a>)
			}
			return (<a className='btn secondary-color white-text' onClick={ () => this.exportStation() }>{ i18n.exportFunction }</a>)
		})()

		const deleteButton = (<a className='btn red' onClick={ () => this.openModal() }>{ i18n.deleteFunction }</a>)
		if (detail) {
			return (<div className='fixed-action-btn horizontal station-function' id='station-function'>
				<a className='btn-floating btn-large red right '>
					<i className='material-icons'>info</i>
				</a>
				<ul>
					<div className='row text-center toolbar-function margin-right-0'>
						<div className='col s12 padding-top-10 '>
							<div className='row'>
								<a className='btn  secondary-color white-text'
								   onClick={ () => this.change(PANEL_DASHBOARD) }>{ i18n.graphicView }</a>
							</div>
							<div className='row'>
								<a className='btn  secondary-color white-text'
								   onClick={ () => this.change(PANEL_DETAIL) }>{ i18n.cartographicView }</a>
							</div>
							<div className='row'>
								{ exportButton }
							</div>
							<div className='row'>
								{ deleteButton }
							</div>
						</div>
					</div>
				</ul>
			</div>)
		}


		return (<div className='fixed-action-btn horizontal station-function' id='station-function'>
			<a className='btn-floating btn-large red right '>
				<i className='material-icons'>info</i>
			</a>
			<ul>
				<div className='row text-center toolbar-function margin-right-0'>
					<div className='col s12 padding-top-10 '>
						<div className='row'>
							{ exportButton }
						</div>
						<div className='row'>
							{ deleteButton }
						</div>
					</div>
				</div>
			</ul>
		</div>)
	}

	render() {
		return (
			<div className='row no-margin'>
				{ this.getContent() }
				<ConfirmationModal id={ this.state.id } content={ '' }
								   title={ 'Suppression du site ' + this.props.station.code } store={ AppStore }
								   actionOnValid={ DashboardAction.deleteSites }
								   values={ [this.props.params.id] }/>
			</div>
		)
	}
}

DetailStationApp.propTypes = {
	params: PropTypes.shape({
		id: PropTypes.string
	}),
	station: PropTypes.objectOf(DtoDetailStation),
	networks: PropTypes.arrayOf(DtoDetailStationNetwork),
	piezometerMeasuresMax: PropTypes.arrayOf(DtoDetailPiezometerMeasure),
	piezometerMeasuresMin: PropTypes.arrayOf(DtoDetailPiezometerMeasure),
	piezometerMeasuresMoyenne: PropTypes.arrayOf(DtoDetailPiezometerMeasure),
	piezometerMeasures: PropTypes.arrayOf(DtoPiezometerMeasure),
	samplingSurfacePoints: PropTypes.arrayOf(PropTypes.instanceOf(DtoDetailStationSamplingSurfacePoint)),
	pickupOperations: PropTypes.arrayOf(PropTypes.instanceOf(DtoPickupOperation)),
	analysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysis)),
	cities: PropTypes.arrayOf(PropTypes.instanceOf(DtoCity))
}
const mapStateToProps = store => {
	return {
		station: store.DetailStationReducer.station,
		networks: store.DetailStationReducer.networks,
		piezometerMeasuresMax: store.DetailStationReducer.piezometerMeasuresMax,
		piezometerMeasuresMin: store.DetailStationReducer.piezometerMeasuresMin,
		piezometerMeasuresMoyenne: store.DetailStationReducer.piezometerMeasuresMoyenne,
		piezometerMeasures: store.DetailStationReducer.piezometerMeasures,
		samplingSurfacePoints: store.DetailStationReducer.samplingSurfacePoints,
		pickupOperations: store.DetailStationReducer.pickupOperations,
		analysis: store.DetailStationReducer.analysis,
		cities: store.ReferentialReducer.cities
	}
}

export default connect(mapStateToProps)(DetailStationApp)



// WEBPACK FOOTER //
// ./src/station/components/DetailStationApp.js